// extracted by mini-css-extract-plugin
module.exports = {"getHelp":"GetHelp_getHelp__ip1uK","label":"GetHelp_label__fty2r","emails":"GetHelp_emails__kIxlj","email":"GetHelp_email__1r6SE","link":"GetHelp_link__2heW_"};